import Reflux from "reflux";

export default Reflux.createActions([
  "hideTooltip",
  "setSlides",
  "setWidths",
  "showTooltip",
  "slidingCompletion",
]);
